import {
  PracticeSetupStepCategory,
  PracticeSetupStepId,
} from '@principle-theorem/principle-core/interfaces';
import { map } from 'rxjs/operators';
import { PracticeSetupStepValidation } from './practice-setup-step-validation';
import {
  IPageVisitTrackingConfig,
  IPracticeSetupStepDefinition,
} from './practice-setup-step.types';
import { initRawSchema } from '@principle-theorem/editor';

const pageVisitTracking: IPageVisitTrackingConfig = {
  routes: ['settings/brand/{brandId}/products'],
  validationMode: 'any',
};

export const productsForSaleStep: IPracticeSetupStepDefinition = {
  id: PracticeSetupStepId.ProductsForSale,
  category: PracticeSetupStepCategory.AdditionalSettings,
  title: 'Set Up Products for Sale',
  description: initRawSchema(
    `Principle allows you to create a library of physical products that can be sold through your practice. Once configured, these products can be added directly to patient invoices at checkout alongside any treatments being billed.`
  ),
  dependsOn: [],
  getRoute: (brand, _practice) => `settings/brand/${brand.ref.id}/products`,
  validate$: (practice$, step, options) => {
    return practice$.pipe(
      map((_practice) => {
        if (options?.reviewed || options?.skipped) {
          return { valid: true };
        }

        const pageVisitValidation =
          PracticeSetupStepValidation.validatePageVisits(
            step,
            pageVisitTracking
          );
        if (pageVisitValidation.valid) {
          return { valid: true };
        }

        return {
          valid: false,
          reason: 'Please review the products before completing this step',
        };
      })
    );
  },
  pageVisitTracking,
};
